import React from 'react';
import TextField from 'material-ui/TextField';

const SearchBar = ({ searchChange }) => (
  <TextField
    className="search-bar"
    name="search"
    floatingLabelText="Search Driver Name"
    style={{ width: '50%' }}
    onChange={searchChange}
  />
);

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/Parking/SearchBar.js